module.exports = __webpack_public_path__ + "b2bf9f27346e580d5b9cf87d6ef50327.ttf";